import React from 'react';
import cx from 'classnames';
import styles from './Textarea.module.scss';

const Textarea = ({ error, ...rest }) => (
  <textarea className={cx(styles.root, { [styles.root_error]: error })} {...rest} />
);

export default Textarea;
